import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";

export interface SliderProps extends Omit<HTMLAttributes<HTMLInputElement>, "onChange"> {
  value?: number;

  onChange?: (value: number) => void;
  className?: string;
}

export function Slider({ value, onChange, className, ...props }: SliderProps) {
  return (
    <input
      type="range"
      min="0"
      max="1"
      step="0.01"
      value={value}
      onChange={(e) => onChange?.(Number(e.target.value))}
      className={cn(
        "w-[80px] h-1 rounded-lg appearance-none cursor-pointer",
        "[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:cursor-pointer",
        "[&::-webkit-slider-thumb]:w-[14px] [&::-webkit-slider-thumb]:h-[14px] [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white [&::-moz-range-thumb]:w-[14px] [&::-moz-range-thumb]:h-[14px] [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-white [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-progress]:bg-white [&::-moz-range-track]:rounded-lg",
        className,
      )}
      style={{
        background: `linear-gradient(to right, white ${value ? value * 100 : 0}%, rgba(255, 255, 255, 0.4) ${value ? value * 100 : 0}%)`,
      }}
      {...props}
    />
  );
}
